import { render } from "./RoleProject.vue?vue&type=template&id=31c218fa"
import script from "./RoleProject.vue?vue&type=script&lang=js"
export * from "./RoleProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__